import { ComponentType, FC, ReactNode } from "react";
import { UIGrid, UIGridSize } from "../../../_app/components";
import { createStylesheet } from "../../../_app/utils/styles";

export interface Props {
  children?: ReactNode;
  md?: UIGridSize;
}

export const withWidget =
  <P extends object>(WrappedComponent: ComponentType<P>, cy?: string, overrides?: any): FC<P & Props> =>
  ({ md = 6, ...props }: Props) => {
    const classes = useStyles();
    return (
      <UIGrid size={{ xs: 12, md: md }} data-cy={cy} className={classes.widget} {...(overrides || {})}>
        <WrappedComponent {...(props as P)} />
      </UIGrid>
    );
  };

const useStyles = createStylesheet(() => ({
  widget: {
    "& .widget-button": {
      width: "fit-content",
    },
    "& .MuiPaper-root": {
      minHeight: 240,
    },
  },
}));
